import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1 : [
  {
    column: "column1",
    columnWidth:"48%",
    rows: {
      row1: [
        {
          name: "exportProductReExportBENumber",
          label: "B/E Number",
          component: "text-field",
          width: "50%",
        },
        {
          name:"exportProductReExportBENumberDate",
          component: "dateselector",
          width: "40%",

        },
        {
          name: "exportProductReExportInit",
          label: "Init",
          component: "outlinebutton",
          action: "openSubDialog",
          subComponent: "ProductReExportInit",
          width: "10%",
          sx: {
            mt: "34px",
          },
        },
      ],
      row2: [
        {
          name: "exportProductReExportInvoiceSerialNo",
          label: "Invoice No",
          component: "text-field",
        },
        {
          name: "exportProductReExportItemSerialNo",
          label: "Item SNo",
          component: "text-field",
        },
      ],
      row3: [
        {
          name: "exportProductReExportImportPortCode",
          label: "Import Port Code",
          component: "text-field",
        },
      ],
      row4: [
        {
          name: "exportProductReExportManualBE",
          checkboxLabel:"Manual B/E",
          component: "checkboxbox",   
         },
      ],
      row5: [
        {
          name: "exportProductReExportBEItemDescription",
          actionText:"B/E item Desc",
          component: "textarea",  
          width: "100%",

         },
      ],
      row6: [
        {
          name: "exportProductReExportQuantityImporterValue",
          label:"Quantity Imported",
          component: "text-field", 
          dataType:"int",
         },
         {
          name: "exportProductReExportQuantityImporterUnit",
          component: "text-field",  
          icon: LuSearch,
          type:"autocomplete",
          endpoint:"getQuantity"
         },
      ],
      row7: [
        {
          name: "exportProductReExportAssessableValue",
          label:"Assessable Value",
          component: "text-field", 
          dataType:"int",
         },
      ],
      row8: [
        {
          name: "exportProductReExportTotalDutyPaid",
          label:"Total Duty Paid",
          component: "text-field", 
          dataType:"int",
          width:"50%"
         },
         {
          name:"exportProductReExportTotalDutyPaidDate",
          component:"dateselector",
         }
      ],
    },
  },
  {
    column: "column2",
    columnWidth:"48%",
    rows: {
      row1: [
        {
          name: "exportProductReExportQuantityExporterValue",
          label:"Quantity Exported",
          component: "text-field",  
          dataType:"int",

         },
         {
          name: "exportProductReExportQuantityExporterUnit",
          component: "text-field",  
          icon: LuSearch,
          type:"autocomplete",
          endpoint:"getQuantity"
         },
      ],
      row2: [
        {
          name: "exportProductReExportTechnicalDetails",
          actionText: "Technical Details",
          component: "textarea",
          width: "100%",
          sx:{height:"110px"},
        },
      ],
      row3: [
        {
          name: "exportProductReExportInputCreditAvailed",
          label:"Input Credit Availed",
          component: "checkboxbox",   
         },
         {
          name: "exportProductReExportPersonalUseItem",
          label:"Personal Use item",
          component: "checkboxbox",   
         },
      ],
      row4: [
        {
          name: "exportProductReExportOtherIdentifyingParameters",
          actionText: "Other Identifying Parameters",
          component: "textarea",
          width: "100%",

        },
      ],
      row5: [
        {
          name: "exportProductReExportAgainstExportObligation",
          label:"Against Export Obligation",
          component: "checkboxbox",   
          width:"50%",
          sx:{mt:"37px"}
         },
         {
          name: "exportProductReExportAgainstExportObligationNo",
          label:"Obligation No.",
          component: "text-field",  
          width:"50%"
         },
      ],
      row6: [
        {
          name: "exportProductReExportDrawbackAmountClaimed",
          label:"Drawback Amt Claimed",
          component: "text-field",  
          dataType:"int",
         },
      ],
      row7: [
        {
          name: "exportProductReExportItemUnused",
          label:"Item Un-Used",
          component: "checkboxbox",   
         },
         {
          name: "exportProductReExportCommissionerPermission",
          label:"Commissioner Permission",
          component: "checkboxbox",   
         },
      ],
      row8: [
        {
          name: "exportProductReExportBoardNumber",
          label:"Board Number",
          component: "text-field", 
            width:"50%"
         },
         {
          name: "exportProductReExportBoardNumberDate",
          component: "dateselector",  
          width:"50%"
         },
      ],
      row9: [
        {
          name: "exportProductReExportBoardMODVATAvailed",
          label:"MODVAT Availed",
          component: "checkboxbox",   
         },
         {
          name: "exportProductReExportBoardMODVATRevised",
          label:"MODVAT Reversed",
          component: "checkboxbox",   
         },
      ],
    },
  },
]
};
